import * as actionTypes from './Actions_name_db'; // IMPORTA LE COSTANTI ACTIONS

import axios from 'axios';
import firebase from '../../hoc/Firebase';

// Si utilizza per settare ad esempio lo stato ad un loading
export const readDataFromFirebaseStart = () => {
    return {
        type: actionTypes.READ_DATA_START
    };
};

export const readDataFromFirebaseSuccess = (wallpapersData, lastNum, categories) => {
    // console.log(wallpapersData);
    return {
        type: actionTypes.READ_DATA_SUCCESS,
        wallpapers: wallpapersData,
        lastNum: lastNum,
        category: categories
    };
};

export const readDataFromFirebaseFail = () => {
    return {
        type: actionTypes.READ_DATA_ERROR
    };
};

export const readCategorySuccess = (wallpapersData, lastNum, categories) => {
    return {
        type: actionTypes.READ_CATEGORIE_SUCCESS,
        wallpapers: wallpapersData,
        lastNum: lastNum,
        category: categories
    };
};


export const readDataFromDB = () => {
    return dispatch => {
        // Chiama read start firebase data
        dispatch(readDataFromFirebaseStart());

        // Inizializzo listener wallpapers firebase
        let database = firebase.database(); // setta il database
        let refWALL = database.ref('wallpapers'); //.child('value'); // setta il nodo;
        let wallpaperData = [];
        let lastNumm = null;
        let categories = [];

        refWALL.on('value', data => {
            // console.log("[REDUCER] - FIREBASE - Observe Wallpapers")
            let wallpapersData = [];
            let wallpapers = data.val(); // return tutti gli oggetti scores
            // sono nel caso ci siano records!
            if (wallpapers !== null) {
                // creo un array con tutte le chiavi delle scores
                let keys = Object.keys(wallpapers);
                // Cicla tutti i dati scorendo le keys
                let lastNum;
                for (var i = 0; i < keys.length; i++) {
                    let k = keys[i];
                    // lastNum = i + 1;
                    lastNum = wallpapers[k].num + 1;
                    // console.log(wallpapers[k].num);
                    // console.log("Chiave: ", k);
                    // console.log(wallpapers[k]);
                    let edited = wallpapers[k]
                    edited.id = k;
                    // edited.num = i; // rimuovo per il semplice fatto che altrimenti viene caricato male il nuovo wallpaper

                    wallpapersData.push(
                        edited
                    );
                }
                wallpaperData = wallpapersData;
                lastNumm = lastNum;
                dispatch(readDataFromFirebaseSuccess(wallpaperData, lastNumm, categories));
            }
        });

        let refCategory = database.ref('categories');
        refCategory.on('value', data => {
            // console.log("[REDUCER] - Category - Observe Category!")
            let wallpapersCategory = [];
            let categoryData = data.val(); // return tutti gli oggetti scores

            console.log("Last num: ", lastNumm);

            // sono nel caso ci siano records!
            if (categoryData !== null) {
                // creo un array con tutte le chiavi delle scores
                let keys = Object.keys(categoryData);
                // Cicla tutti i dati scorendo le keys
                for (var i = 0; i < keys.length; i++) {
                    let k = keys[i];
                    // console.log("Chiave: ", k);
                    // console.log(wallpapers[k]);
                    let edited = categoryData[k]
                    edited.id = k;
                    edited.num = i;

                    

                    wallpapersCategory.push(
                        edited
                    );
                }
                categories = wallpapersCategory;
                dispatch(readCategorySuccess(wallpaperData, lastNumm, categories));
            }

        });


    };
};

export const updateWallpaperSuccess = () => {
    return {
        type: actionTypes.UPDATE_WALLPAPER_SUCCESS
    };
};

export const updateDataWallpaper = (id, stateNow) => {
    return dispatch => {
        // console.log("[Reducer] - updateDataWallpaper: ID: ", id);
    
        // Set new data on Firebase DB
        let database = firebase.database(); // setta il database
        let ref = database.ref('wallpapers/' + id); // .child(prevState[e.target.id].id); // setta il nodo;
        // Update Object
        ref.update(stateNow);

        // REQUEST JSON VERSION
        axios.get('https://wallpapers-app-7e425.firebaseio.com/version.json')
            .then(function (response) {
                //console.log(response);
                let data = response.data;
                console.log("[JSON-VERSION] - Json Version: ", data.version);

                // Update Version Json
                let refVersion = database.ref('version');
                let version = {
                    version: data.version + 1
                };
                refVersion.update(version);

            })
            .catch(function (error) {
                console.log("Catch Error Json Version: ", error);
            });
        
        dispatch(updateWallpaperSuccess());
    }
}

export const deleteWallpaperSuccess = (wallpapersData) => {
    return {
        type: actionTypes.DELETE_WALLPAPER_SUCCESS,
        wallpapers: wallpapersData,
    };
};

export const deleteWallpaper = (record, prevState) => {
    return dispatch => {
        // console.log("[Reducer] - Delete wallpaper with ID; ", record, "PREV STATE: ", prevState);

        
        var dataRefImage = firebase.storage().ref(`images/${record.nameImage}`);

        // remove file
        dataRefImage.delete().then(function () {
            // File deleted successfully
            // console.log("Remove Image Completed!");
        }).catch(function (error) {
            // Uh-oh, an error occurred!
            // console.log("Errore remove images: ", error);
        });

        // rimuovi il video nel caso esista
        if (record.nameVideo !== "") {
            var dataRefVideo = firebase.storage().ref(`videos/${record.nameVideo}`);
            dataRefVideo.delete().then(function () {
                // File deleted successfully
                // console.log("Remove Video Completed!");
            }).catch(function (error) {
                // Uh-oh, an error occurred!
                console.log("Errore remove Video: ", error);
            });
        }


        // remove record from Live Database
        let database = firebase.database(); // setta il database
        let recordRef = database.ref('wallpapers/' + record.id);
        recordRef.remove();

        // REQUEST JSON VERSION
        axios.get('https://wallpapers-app-7e425.firebaseio.com/version.json')
            .then(function (response) {
                //console.log(response);
                let data = response.data;
                console.log("[JSON-VERSION] - Result json versione: ", data.version);

                // Update Version Json
                let refVersion = database.ref('version');
                let version = {
                    version: data.version + 1
                };
                refVersion.update(version);

            })
            .catch(function (error) {
                console.log("Catch Error Json Version: ", error);
            });

        dispatch(deleteWallpaperSuccess(prevState));
    }
}